import React, { useState, useEffect } from 'react';
import {object, func, bool, string} from 'prop-types';

import {CloneObject} from '../../../utils/helpers';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import {useFormErrors} from '../../hooks/useFormErrors';
import {isEmptyString, isValidNumber, OnKeyPress_validInteger} from '../../../utils/validator';
import {
    DatePickerCustom,
    InputEntidad,
    InputPersona,
    InputExpediente,
    InputTasa,
    InputSubTasa,
    InputNumber,
    FormError,
    FormLabel,
    Modal
} from '../../common';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import {TIPS} from "../../../consts/tips";
import {Accordion} from "../../common";

const ObraInmuebleModal = (props) => {

    const entityInit = {
        id: 0,
        idInmueble: 0,
        idTasa: 0,
        idSubTasa: 0,
        idTipoMovimiento: 0,
        numero: '',
        cuota: 0,
        importe: 0,
        fechaPrimerVencimiento: null,
        fechaSegundoVencimiento: null,
        idExpediente: 0,
        detalleExpediente: '',
        idTipoPersona: 0,
        idPersona: 0,
        nombrePersona: '',
        idTipoDocumento: 0,
        numeroDocumento: '',
        fechaPresentacion: null,
        fechaInspeccion: null,
        fechaAprobacion: null,
        fechaInicioDesglose: null,
        fechaFinDesglose: null,
        fechaFinObra: null,
        fechaArchivado: null,
        fechaIntimado: null,
        fechaVencidoIntimado: null,
        fechaMoratoria: null,
        fechaVencidoMoratoria: null
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
    });
    const [persona, setPersona] = useState({
        idTipoPersona: 0,
        nombrePersona: "",
        numeroDocumento: "",
        idTipoDocumento: 0
    });
    const [expediente, setExpediente] = useState({
        detalleExpediente: ""
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity}
        });
        setPersona({
            idTipoPersona: props.data.entity.idTipoPersona,
            nombrePersona: props.data.entity.nombrePersona,
            numeroDocumento: props.data.entity.numeroDocumento,
            idTipoDocumento: props.data.entity.idTipoDocumento
        });
        setExpediente({
            detalleExpediente: props.data.entity.detalleExpediente
        });
        formSet({
            idTasa: props.data.entity.idTasa,
            idSubTasa: props.data.entity.idSubTasa,
            idTipoMovimiento: props.data.entity.idTipoMovimiento,
            numero: props.data.entity.numero,
            cuota: props.data.entity.cuota,
            importe: props.data.entity.importe,
            fechaPrimerVencimiento: props.data.entity.fechaPrimerVencimiento,
            fechaSegundoVencimiento: props.data.entity.fechaSegundoVencimiento,
            idExpediente: props.data.entity.idExpediente,
            idPersona: props.data.entity.idPersona,
            fechaPresentacion: props.data.entity.fechaPresentacion,
            fechaInspeccion: props.data.entity.fechaInspeccion,
            fechaAprobacion: props.data.entity.fechaAprobacion,
            fechaInicioDesglose: props.data.entity.fechaInicioDesglose,
            fechaFinDesglose: props.data.entity.fechaFinDesglose,
            fechaFinObra: props.data.entity.fechaFinObra,
            fechaArchivado: props.data.entity.fechaArchivado,
            fechaIntimado: props.data.entity.fechaIntimado,
            fechaVencidoIntimado: props.data.entity.fechaVencidoIntimado,
            fechaMoratoria: props.data.entity.fechaMoratoria,
            fechaVencidoMoratoria: props.data.entity.fechaVencidoMoratoria
        });
    }
    useEffect(mount, [props.data.entity]);


    const [formValues, formHandle, , formSet] = useForm({
        idTasa: 0,
        idSubTasa: 0,
        idTipoMovimiento: 0,
        numero: '',
        cuota: 0,
        importe: 0,
        fechaPrimerVencimiento: null,
        fechaSegundoVencimiento: null,
        idExpediente: 0,
        idPersona: 0,
        fechaPresentacion: null,
        fechaInspeccion: null,
        fechaAprobacion: null,
        fechaInicioDesglose: null,
        fechaFinDesglose: null,
        fechaFinObra: null,
        fechaArchivado: null,
        fechaIntimado: null,
        fechaVencidoIntimado: null,
        fechaMoratoria: null,
        fechaVencidoMoratoria: null
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        let row = CloneObject(state.entity);

        row.idTasa = parseInt(formValues.idTasa);
        row.idSubTasa = !isEmptyString(formValues.idSubTasa) ? parseInt(formValues.idSubTasa) : 0;
        row.idTipoMovimiento = parseInt(formValues.idTipoMovimiento);
        row.numero = formValues.numero;
        row.cuota = formValues.cuota;
        row.importe = formValues.importe;
        row.fechaPrimerVencimiento = formValues.fechaPrimerVencimiento;
        row.fechaSegundoVencimiento = formValues.fechaSegundoVencimiento;
        row.idExpediente = !isEmptyString(formValues.idExpediente) ? parseInt(formValues.idExpediente) : 0;
        row.detalleExpediente = expediente.detalleExpediente;
        row.idPersona = parseInt(formValues.idPersona);
        row.idTipoPersona = persona.idTipoPersona;
        row.idTipoDocumento = persona.idTipoDocumento;
        row.numeroDocumento = persona.numeroDocumento;
        row.nombrePersona = persona.nombrePersona;
        row.fechaPresentacion = formValues.fechaPresentacion;
        row.fechaInspeccion = formValues.fechaInspeccion;
        row.fechaAprobacion = formValues.fechaAprobacion;
        row.fechaInicioDesglose = formValues.fechaInicioDesglose;
        row.fechaFinDesglose = formValues.fechaFinDesglose;
        row.fechaFinObra = formValues.fechaFinObra;
        row.fechaArchivado = formValues.fechaArchivado;
        row.fechaIntimado = formValues.fechaIntimado;
        row.fechaVencidoIntimado = formValues.fechaVencidoIntimado;
        row.fechaMoratoria = formValues.fechaMoratoria;
        row.fechaVencidoMoratoria = formValues.fechaVencidoMoratoria;

        props.onConfirm(row);
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idTasa <= 0) errors.idTasa = VALIDATION_MESSAGE.REQUIRED_OPTION;

        return errors;
    }

    return (
        <>

            <Modal
                size="lg"
                title={`Obra: ${(state.entity.id > 0) ? state.entity.numero : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.OBRA_INMUEBLE_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">
                                <div className="mb-3 col-12">
                                    <Accordion title="Detalle de obra" startOpen={true}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-6">
                                                <FormLabel htmlFor="idTasa" required>Tasa</FormLabel>
                                                <InputTasa
                                                    name="idTasa"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTasa') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTasa}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('idTasa')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6">
                                                <label htmlFor="idSubTasa" className="form-label">Sub tasa</label>
                                                <InputSubTasa
                                                    name="idSubTasa"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idSubTasa}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    idTasa={formValues.idTasa}
                                                />
                                            </div>
                                            {/*
                                                  <div className="mb-3 col-12 col-md-4">
                                                      <label htmlFor="id" className="form-label">Tipo de movimiento</label>
                                                      <InputEntidad
                                                          name="idTipoMovimiento"
                                                          tipName={TIPS.NAME.MODALS.TIPO_MOVIMIENTO_MODAL}
                                                          placeholder=""
                                                          className="form-control"
                                                          value={ formValues.idTipoMovimiento }
                                                          onChange={ formHandle }
                                                          disabled={props.disabled}
                                                          entidad="TipoMovimiento"
                                                      />
                                                  </div>
                                                  <div className="mb-3 col-12 col-md-1">
                                                      <label htmlFor="numero" className="form-label">N°</label>
                                                      <input
                                                          name="numero"
                                                          type="text"
                                                          placeholder=""
                                                          className="form-control"
                                                          value={ formValues.numero }
                                                          onChange={ formHandle }
                                                          onKeyPress={ OnKeyPress_validInteger }
                                                          disabled={props.disabled}
                                                      />
                                                  </div>
                                                  <div className="mb-3 col-12 col-md-1">
                                                      <label htmlFor="cuota" className="form-label">Cuota</label>
                                                      <InputNumber
                                                          name="cuota"
                                                          placeholder=""
                                                          className="form-control"
                                                          value={formValues.cuota }
                                                          precision={0}
                                                          onChange={ formHandle }
                                                          disabled={props.disabled}
                                                      />
                                                  </div>
                                                  <div className="mb-3 col-12 col-md-3">
                                                      <label htmlFor="fechaPrimerVencimiento" className="form-label">Primer vencimiento</label>
                                                      <DatePickerCustom
                                                          name="fechaPrimerVencimiento"
                                                          placeholder=""
                                                          className="form-control"
                                                          value={ formValues.fechaPrimerVencimiento }
                                                          onChange={ formHandle }
                                                          disabled={props.disabled}
                                                      />
                                                  </div>
                                                  <div className="mb-3 col-12 col-md-3">
                                                      <label htmlFor="fechaSegundoVencimiento" className="form-label">Segundo vencimiento</label>
                                                      <DatePickerCustom
                                                          name="fechaSegundoVencimiento"
                                                          placeholder=""
                                                          className="form-control"
                                                          value={ formValues.fechaSegundoVencimiento }
                                                          onChange={ formHandle }
                                                          disabled={props.disabled}
                                                      />
                                                  </div>
                                                */}
                                            <hr className="mb-3"/>
                                            <div className="mb-3 col-12 col-md-3">
                                                <label htmlFor="idExpediente"
                                                       className="form-label">Expediente</label>
                                                <InputExpediente
                                                    name="idExpediente"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idExpediente}
                                                    onChange={(event) => {
                                                        const {target} = event;
                                                        const expediente = (target.row) ? {
                                                            detalleExpediente: target.row.detalleExpediente,
                                                        } : {
                                                            detalleExpediente: ""
                                                        };
                                                        setExpediente(expediente);
                                                        formHandle(event);
                                                    }}
                                                    disabled={props.disabled}
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-md-3">
                                                <label htmlFor="cuota" className="form-label">Importe</label>
                                                <InputNumber
                                                    name="importe"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.importe}
                                                    precision={2}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                            </div>
                                            <div className="mb-3 col-6">
                                                <label htmlFor="idPersona"
                                                       className="form-label">Profesional</label>
                                                <InputPersona
                                                    name="idPersona"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idPersona}
                                                    idTipoPersona={0}
                                                    onChange={(event) => {
                                                        const {target} = event;
                                                        const persona = (target.row) ? {
                                                            idTipoPersona: target.row.idTipoPersona,
                                                            idTipoDocumento: target.row.idTipoDocumento,
                                                            numeroDocumento: target.row.numeroDocumento,
                                                            nombrePersona: target.row.nombrePersona
                                                        } : {
                                                            idTipoPersona: 0,
                                                            idTipoDocumento: 0,
                                                            numeroDocumento: "",
                                                            nombrePersona: ""
                                                        };
                                                        setPersona(persona);
                                                        formHandle(event);
                                                    }}
                                                    disabled={props.disabled}
                                                />
                                            </div>
                                            <hr className="mb-3"/>
                                            <div className="mb-3 col-12 col-md-3">
                                                <label htmlFor="fechaPresentacion"
                                                       className="form-label">Presentación</label>
                                                <DatePickerCustom
                                                    name="fechaPresentacion"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.fechaPresentacion}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-md-3">
                                                <label htmlFor="fechaInspeccion"
                                                       className="form-label">Inspección</label>
                                                <DatePickerCustom
                                                    name="fechaInspeccion"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.fechaInspeccion}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-md-3">
                                                <label htmlFor="fechaAprobacion"
                                                       className="form-label">Aprobación</label>
                                                <DatePickerCustom
                                                    name="fechaAprobacion"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.fechaAprobacion}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                            </div>
                                            {/*
                                                  <div className="mb-3 col-12 col-md-3">
                                                      <label htmlFor="fechaInicioDesglose" className="form-label">Inicio desglose</label>
                                                      <DatePickerCustom
                                                          name="fechaInicioDesglose"
                                                          placeholder=""
                                                          className="form-control"
                                                          value={ formValues.fechaInicioDesglose }
                                                          onChange={ formHandle }
                                                          disabled={props.disabled}
                                                      />
                                                  </div>

                                                  <div className="mb-3 col-12 col-md-3">
                                                      <label htmlFor="fechaFinDesglose" className="form-label">Fin desglose</label>
                                                      <DatePickerCustom
                                                          name="fechaFinDesglose"
                                                          placeholder=""
                                                          className="form-control"
                                                          value={ formValues.fechaFinDesglose }
                                                          onChange={ formHandle }
                                                          disabled={props.disabled}
                                                      />
                                                  </div>
                                                  */}
                                            <div className="mb-3 col-12 col-md-3">
                                                <label htmlFor="fechaFinObra" className="form-label">Final
                                                    obra</label>
                                                <DatePickerCustom
                                                    name="fechaFinObra"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.fechaFinObra}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                            </div>
                                            {/*
                                                  <div className="mb-3 col-12 col-md-3">
                                                      <label htmlFor="fechaArchivado" className="form-label">Archivado</label>
                                                      <DatePickerCustom
                                                          name="fechaArchivado"
                                                          placeholder=""
                                                          className="form-control"
                                                          value={ formValues.fechaArchivado }
                                                          onChange={ formHandle }
                                                          disabled={props.disabled}
                                                      />
                                                  </div>
                                                  <div className="mb-3 col-12 col-md-3">
                                                      <label htmlFor="fechaIntimado" className="form-label">Intimado</label>
                                                      <DatePickerCustom
                                                          name="fechaIntimado"
                                                          placeholder=""
                                                          className="form-control"
                                                          value={ formValues.fechaIntimado }
                                                          onChange={ formHandle }
                                                          disabled={props.disabled}
                                                      />
                                                  </div>
                                                  <div className="mb-3 col-12 col-md-3">
                                                      <label htmlFor="fechaVencidoIntimado" className="form-label">Vencido intimado</label>
                                                      <DatePickerCustom
                                                          name="fechaVencidoIntimado"
                                                          placeholder=""
                                                          className="form-control"
                                                          value={ formValues.fechaVencidoIntimado }
                                                          onChange={ formHandle }
                                                          disabled={props.disabled}
                                                      />
                                                  </div>
                                                  <div className="mb-3 col-12 col-md-3">
                                                      <label htmlFor="fechaMoratoria" className="form-label">Moratoria</label>
                                                      <DatePickerCustom
                                                          name="fechaMoratoria"
                                                          placeholder=""
                                                          className="form-control"
                                                          value={ formValues.fechaMoratoria }
                                                          onChange={ formHandle }
                                                          disabled={props.disabled}
                                                      />
                                                  </div>
                                                  <div className="mb-3 col-12 col-md-3">
                                                      <label htmlFor="fechaVencidoMoratoria" className="form-label">Vencido moratoria</label>
                                                      <DatePickerCustom
                                                          name="fechaVencidoMoratoria"
                                                          placeholder=""
                                                          className="form-control"
                                                          value={ formValues.fechaVencidoMoratoria }
                                                          onChange={ formHandle }
                                                          disabled={props.disabled}
                                                      />
                                                  </div>
                                                  */}
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de Obra"
                                            tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_OBRA_INMUEBLE_MODAL}
                                            processKey={props.processKey}
                                            entidad="ObraInmueble"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>

                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}

ObraInmuebleModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

ObraInmuebleModal.defaultProps = {
    disabled: false
};

export default ObraInmuebleModal;